// extracted by mini-css-extract-plugin
module.exports = {"share":"Share_share__1Yc5G","icon":"Share_icon__LtHwV"};